<template>
  <router-link
    :to="{ name: 'roadmap', params: { projectId: route.params.projectId } }"
    class="comment__idea-converted-card"
  >
    <span class="comment__idea-converted-card__title">{{ featureTitle }}</span>
    <icon
      data="@icon/link-on.svg"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      color="var(--monochrome-05)"
      class="comment__idea-converted-card__icon"
    />
  </router-link>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router"
import { computed } from "vue"

import { Comment } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const route = useRoute()

const featureTitle = computed(() => props.comment.ideaAuditRecord?.after?.featureTitle ?? "")
</script>

<style scoped lang="scss">
@import "@/assets/scss/utils/mixins/_flex";
@import "@/assets/scss/utils/mixins/_ellipsis";
@import "@/assets/scss/utils/typography-v2";

.comment__idea-converted-card {
  min-height: 40px;
  padding: var(--step2) var(--step4);
  border: 1px solid var(--monochrome02to36);
  border-radius: var(--radius-item);
  background: var(--monochrome-00);
  gap: var(--step4);

  @at-root .dark & {
    background: var(--monochrome-24);
  }

  &__title {
    @include body-medium-400;
    @include ellipsis;

    color: var(--monochrome-07);
  }

  &__icon {
    flex-shrink: 0;
  }

  &:hover &__icon :deep(path) {
    fill: var(--monochrome-06);
  }
}
</style>
